(function () {

    var formApp = angular.module("formApp");

    formApp.controller('layoutController',
        [
            '$scope', '$timeout', '$interval', 'DataServices', 'UtilityServices', '$rootScope', 'Constants',
            function ($scope, $timeout, $interval, DataServices, UtilityServices, $rootScope, Constants) {
                $scope.utility = UtilityServices;

                $rootScope.$on("adal:acquireTokenFailure",
                    function () {
                        $scope.utility.handleSessionTimeOut();
                    });

                $scope.openFmsAdminSite = function () {
                    DataServices.navigateToAdminFmsSite();
                }

                $scope.navs = {
                    manageFeedbacks: Constants.Url.manageFeedbacks,
                    manageComplaints: Constants.Url.manageComplaints,
                    tools: Constants.Url.tools
                };               

                $timeout(function () {
                    $scope.utility.setMenuVisibility();
                    $scope.userFullName = DataServices.userFullName();
                    $scope.salutation = $scope.userFullName ? ('Hello, ' + $scope.userFullName + '!') : '';
                }, 0);
            }]);

        

}());